exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cost-confirmation-summary .table-container[data-v-19361c08] {\n  margin-top: 16px;\n}\n.cost-confirmation-summary .pagination-container[data-v-19361c08] {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 16px;\n  background-color: #fff;\n  border-radius: 4px;\n}\n", ""]);

// exports
